export function findVariablesInStringFunction(value: string, strict: boolean = true, strictExpressionMatch: boolean = false): string[] {
  const ALLOWED_PARAMETERS_STRICT = ['Math.pow(', 'Math.min('];
  const ALLOWED_PARAMETERS_NON_STRICT = ['Math.pow(', 'Math.min(', 'WEIGHT', 't', 'atoc_lhs', 'atoc_rhs', 'unknown_x'];
  const allowedParameters = strict ? ALLOWED_PARAMETERS_STRICT : ALLOWED_PARAMETERS_NON_STRICT;
  const variables = value
    ? value
        .split(' ')
        .filter((paramName) => paramName.match(/[a-zA-Z]/))
        .filter((p) => !allowedParameters.includes(p))
    : [];
  return strictExpressionMatch && variables.length > 1 ? [] : variables;
}
